<template>
    <div>
        <label v-text="getLabel"></label>
        <div class="image" v-if="hasImage">
            <a :href="currentValue" target="_blank">
                <img :src="currentValue" class="thumbnail" v-if="hasImage">
                <img src="/images/products/no-photo.jpg" class="thumbnail" v-else/>
            </a>
        </div>
        <div class="form-group">
            <label :for="getId">
                <input type="file"
                       :id="getId"
                       ref="file"
                       @change="upload"/>
            </label>
        </div>
    </div>

</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo
        ],
        methods: {
            upload() {
                let formData = new FormData();
                formData.append('file', this.$refs.file.files[0]);
                formData.append('type', 'image'); //@todo onderscheid maken tussen image en background

                if (this.hasImage) {
                    formData.append('old', this.currentValue)
                }

                axios.post(`/api/backend/composer/rows/images/`, formData)
                    .then(response => {
                        this.currentValue = response.data.data.path;
                    }).catch(error => {
                    console.error(error);
                });
            },
        },
        computed: {
            hasImage() {
                return this.currentValue !== '';
            },
        }
    }
</script>

<style scoped>
    .thumbnail {
        max-width: 50%;
        max-height: 200px;
    }
</style>
